import morphdom from 'morphdom';
import AsyncView from '@pixelunion/shopify-asyncview';
import rimg from '@pixelunion/rimg-shopify';

export default class ProductHighVariant {
  constructor(el) {
    this.el = el;

    // Prevent cart redirection
    document.addEventListener('product-form:cart:navigate', event => {
      event.preventDefault();
    });

    // Handle successful cart addition
    document.addEventListener('product-form:submit:success', () => {
      this.updateMiniCart();
    });
  }

  updateMiniCart() {
    document.querySelector('.mini-cart').classList.remove('empty');
    const miniCartItemWrapper = document.querySelector('.mini-cart-item-wrapper');
    const cartCount = document.querySelectorAll('.cart-count-number');

    AsyncView.load(
      window.Theme.routes.cart_url,
      { view: 'mini-ajax' },
    )
      .then(({ data, html }) => {
        const updatedMiniCart = document.createElement('div');
        updatedMiniCart.innerHTML = html.miniCart;
        cartCount.forEach(el => { el.innerText = data.itemCount; });

        morphdom(
          miniCartItemWrapper,
          updatedMiniCart.querySelector('.mini-cart-item-wrapper'),
          {
            onBeforeElUpdated: (fromEl, toEl) => {
              if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
                return false;
              }
              return true;
            },
          },
        );
      });

    rimg.watch(miniCartItemWrapper);
  }
}
